import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BackToTopButton from "./components/BacktoTop";
import MapWithMarker from "./components/MapWithMarker";
import MouseFollowerBackground from "./components/Mousefollowbackground";
import Home from "./pages/Home";
import About from "./pages/About";
import Service from "./pages/Service";
import Contact from "./pages/Contact";
import ServiceDetail from "./pages/ServiceDetail";
import Training from "./pages/Training";
import Career from "./pages/Career";
import Location from "./pages/Location";
import Emergencies from "./pages/Emergencies";
import Technology from "./pages/Technology";
import Privacypolicy from "./pages/Privacypolicy";
import Termsofuse from "./pages/Termsofuse";

export default function App() {
  return (
    <Router>
      <div className="text-white font-sans min-h-screen flex flex-col relative min-h-screen overflow-x-hidden">
        <div className="fixed top-0 left-0 w-full h-full z-0 pointer-events-none opacity-25 bg-center bg-contain bg-no-repeat">
          <MapWithMarker />
        </div>
        <main className="flex-grow relative z-10">
          <MouseFollowerBackground />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Service />} />
            <Route path="/services/:id" element={<ServiceDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/training" element={<Training />} />
            <Route path="/career" element={<Career />} />
            <Route path="/location" element={<Location />} />
            <Route path="/emergencies" element={<Emergencies />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/termsofuse" element={<Termsofuse />} />
            <Route path="/privacy-policy" element={<Privacypolicy />} />
          </Routes>
          <BackToTopButton />
          <Footer />
        </main>
      </div>
    </Router>
  );
}
